<!--
 * @Descripttion: 报表编辑
 * @Author: zenghua.wang
 * @Date: 2021-05-11 10:31:28
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-08-02 10:02:11
-->
<template>
  <el-dialog :title="title" :visible.sync="visible" append-to-body class="xa-dialog">
    <el-form class="xa-dialog-body" inline :model="form" :size="option.size" @submit.native.prevent label-width="160px"
      label-suffix="：">
      <template v-for="(item, index) in option.column">
        <template v-if="item.showType != 'hide'">
          <el-form-item :key="index" v-if="item.type === 'text'" class="row-50" :label="item.label">
            <el-input placeholder="请输入" clearable :disabled="!editable" v-model="form[item.prop]"></el-input>
          </el-form-item>

          <el-form-item :key="index" v-if="item.type === 'textarea'" class="row-100" :label="item.label">
            <el-input placeholder="请输入" type="textarea" :rows="2" :disabled="!editable"
              v-model="form[item.prop]"></el-input>
          </el-form-item>

          <el-form-item :key="index" v-if="item.type === 'number'" class="row-50" :label="item.label">
            <el-input placeholder="请输入" clearable :disabled="!editable" v-model="form[item.prop]"></el-input>
          </el-form-item>

          <el-form-item :key="index" v-if="item.type === 'select'" class="row-50" :label="item.label">
            <el-select v-model="form[item.prop]" clearable placeholder="请选择" :disabled="!editable">
              <el-option v-for="dic in item.dicData" :key="dic.value" :label="dic.label" :disabled="dic.disabled"
                :value="dic.value"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :key="index" v-if="['date', 'datetime', 'daterange'].includes(item.type)" class="row-50"
            :label="item.label">
            <el-input placeholder="请输入" clearable :disabled="!editable" v-model="form[item.prop]"></el-input>
          </el-form-item>
        </template>
      </template>
    </el-form>
    <span slot="footer" class="xa-dialog-footer" v-if="editable">
      <el-button :size="option.size" type="primary" icon="el-icon-circle-check" @click="onEditSubmit">修改</el-button>
      <el-button :size="option.size" @click="visible = false" icon="el-icon-circle-close">取 消</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'report-edit',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '编辑'
    },
    editable: {
      type: Boolean,
      default: false
    },
    option: {
      type: Object,
      default: () => { }
    },
    row: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      visible: false,
      form: {}
    }
  },
  watch: {
    show(val) {
      this.visible = val
      if (this.row != null) {
        this.form = this.row
      }
    },
    visible: {
      handler(val) {
        this.$emit('update:show', val)
      },
      deep: true
    }
  },
  methods: {
    onEditSubmit() {
      this.visible = false
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/dragComponents/styles/variables.scss";

.xa-dialog-body {
  :deep(.el-form-item) {
    margin-right: 0;
  }
}

.row {
  &-100 {
    width: 100%;
  }

  &-50 {
    width: 50%;
  }
}
</style>
